import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirLocationLink } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirLocationLinksAdapter = createEntityAdapter<JSONApiDataObject<BsdirLocationLink>>({
  selectId: item => item.id
});

export const bsdirLocationLinksSlice = createSlice({
  name: 'bsdirLocationLinks',
  initialState: bsdirLocationLinksAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirLocationLink>),
  reducers: {
    bsdirLocationLinksAdded: (state, action) => {
      bsdirLocationLinksAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirLocationLinksSelectors = bsdirLocationLinksAdapter.getSelectors(
  (state: RootState) => state.bsdir.locationLinks);
export default bsdirLocationLinksSlice.reducer;
